import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { contactAPI } from '../utils/api';

const Contact = () => {
 const { toast } = useToast();
 const [formData, setFormData] = useState({
 parentName: '',
 email: '',
 phone: '',
 childAge: '',
 message: ''
 });
 const [isSubmitting, setIsSubmitting] = useState(false);

 const handleChange = (e) => {
 const { name, value } = e.target;
 setFormData(prev => ({
 ...prev,
 [name]: value
 }));
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 setIsSubmitting(true);

 try {
 const result = await contactAPI.submitContact(formData);

 toast({
 title: "Interest Registered",
 description: result.message || "Thank you for your interest in Nova Roots. We'll be in touch soon.",
 });

 // Reset form
 setFormData({
 parentName: '',
 email: '',
 phone: '',
 childAge: '',
 message: ''
 });
 } catch (error) {
 console.error('Error submitting form:', error);
 toast({
 title: "Submission Failed",
 description: "There was an error submitting your form. Please try again.",
 variant: "destructive",
 });
 } finally {
 setIsSubmitting(false);
 }
 };

 return (
 <div className="contact-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Register Interest</h1>
 <p className="page-subtitle">
 Begin the conversation about Nova Roots.
 </p>
 </div>
 </section>

 <section className="contact-form-section">
 <div className="section-container">
 <div className="contact-content">
 <div className="contact-intro">
 <Card className="intro-card">
 <CardContent className="intro-content">
 <h2>Let's Start a Conversation</h2>
 <p>
 If you're interested in Nova Roots for your child, we'd love to hear from you. 
 Share some basic information and we'll be in touch to discuss next steps.
 </p>
 <p>
 This is not an application—it's simply a way to express interest and begin the 
 conversation.
 </p>
 </CardContent>
 </Card>
 </div>

 <div className="contact-form-wrapper">
 <Card className="form-card">
 <CardContent className="form-content">
 <form onSubmit={handleSubmit} className="contact-form">
 <div className="form-group">
 <Label htmlFor="parentName">Parent/Guardian Name *</Label>
 <Input
 id="parentName"
 name="parentName"
 type="text"
 value={formData.parentName}
 onChange={handleChange}
 required
 placeholder="Your full name"
 />
 </div>

 <div className="form-group">
 <Label htmlFor="email">Email Address *</Label>
 <Input
 id="email"
 name="email"
 type="email"
 value={formData.email}
 onChange={handleChange}
 required
 placeholder="your.email@example.com"
 />
 </div>

 <div className="form-group">
 <Label htmlFor="phone">Phone Number *</Label>
 <Input
 id="phone"
 name="phone"
 type="tel"
 value={formData.phone}
 onChange={handleChange}
 required
 placeholder="+254 xxx xxx xxx"
 />
 </div>

 <div className="form-group">
 <Label htmlFor="childAge">Child's Age</Label>
 <Input
 id="childAge"
 name="childAge"
 type="text"
 value={formData.childAge}
 onChange={handleChange}
 placeholder="e.g., 6 years old"
 />
 </div>

 <div className="form-group">
 <Label htmlFor="message">Tell Us More (Optional)</Label>
 <Textarea
 id="message"
 name="message"
 value={formData.message}
 onChange={handleChange}
 placeholder="What brings you to Nova Roots? What are you looking for in your child's education?"
 rows={5}
 />
 </div>

 <Button 
 type="submit" 
 className="submit-button"
 disabled={isSubmitting}
 >
 {isSubmitting ? 'Submitting...' : 'Register Interest'}
 </Button>
 </form>
 </CardContent>
 </Card>
 </div>
 </div>
 </div>
 </section>

 <section className="what-next-section">
 <div className="section-container">
 <h2 className="section-title">What Happens Next?</h2>
 <div className="what-next-content">
 <div className="next-step">
 <div className="step-number">1</div>
 <div className="step-content">
 <h3>We'll Review Your Information</h3>
 <p>We read every submission carefully and thoughtfully.</p>
 </div>
 </div>
 <div className="next-step">
 <div className="step-number">2</div>
 <div className="step-content">
 <h3>We'll Reach Out</h3>
 <p>We'll contact you within a week to schedule an initial conversation.</p>
 </div>
 </div>
 <div className="next-step">
 <div className="step-number">3</div>
 <div className="step-content">
 <h3>We'll Explore Fit Together</h3>
 <p>We'll discuss Nova Roots in depth and explore whether there's alignment.</p>
 </div>
 </div>
 </div>
 </div>
 </section>
 </div>
 );
};

export default Contact;